<template>
    <v-navigation-drawer dark absolute fixed :value="open">
        <v-toolbar flat>
        <v-list>
            <v-list-tile>
            <v-list-tile-title class="title">
                Menu
            </v-list-tile-title>
            </v-list-tile>
        </v-list>
        </v-toolbar>

        <v-divider></v-divider>

        <v-list dense class="pt-0">
            <v-list-tile
                v-for="item in items"
                :key="item.title"
                @click="onClick(item.action)"
            >
                <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>

        <v-divider></v-divider>
        <v-list dense class="pt-0">
            <v-list-tile
                v-for="item in items2"
                :key="item.title"
                @click="onClick(item.action)"
            >
                <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
        
        <v-btn v-if="notificationSupported" @click="requestNotificationPermission" variant="danger">{{ hasSubscriptions?'Actualizar Subscripción':'Subscribirse a las notificaciones' }}</v-btn>
    </v-navigation-drawer>
</template>
<script>
import * as actionTypes from '../../../store/actionTypes';
import * as commitTypes from '../../../store/commitTypes';
import {mapActions, mapGetters} from 'vuex';

export default {
    data(){
        return {
            open: false,
            items: [
                {
                    title: 'Mi Cuenta',
                    icon: 'account_box',
                    action: 'my-account'
                },
                {
                    title: 'Cerrar Sesión',
                    icon: 'exit_to_app',
                    action: 'logout'
                }
            ],
            items2: [
                {
                    title: 'Inicio',
                    icon: 'home',
                    action: 'home'
                },
                {
                    title: 'Visitas',
                    icon: 'people',
                    action: 'visits'
                },
                {
                    title: 'Correspondencia',
                    icon: 'mail',
                    action: 'mail'
                },
                {
                    title: 'Circulares',
                    icon: 'announcement',
                    action: 'broadcastMessages'
                },
                {
                    title: 'Conoce a Shatter',
                    icon: 'favorite',
                    action: 'meet-shatter'
                }
            ]
        }
    },
    computed: {
        ...mapGetters(['hasSubscriptions']),
        notificationSupported(){
            return 'Notification' in window;
        }
    },
    methods: {
        ...mapActions({
            subscribe: actionTypes.UPDATE_SUBSCRIPTION
        }),
        setEvents(){
            this.$bus.$on('nav-drawer.toggle', () => this.open = !this.open);
        },
        initialize(){
            this.setEvents();
        },
        onClick(action){
            switch(action){
                case 'home':
                    this.$router.push({name: 'home'});
                    break;
                case 'my-account':
                    this.$router.push({ name: 'MyAccount' });
                    break;
                case 'visits': 
                    this.$router.push({ name: 'visits' });
                    break;
                case 'mail':
                    this.$router.push({ name: 'mail' });
                    break;
                case 'broadcastMessages':
                    this.$router.push({ name: 'broadcastMessages' });
                    break;
                case 'meet-shatter':
                    this.$router.push({ name: 'shatter' });
                    break;
                case 'logout':
                    this.$store.dispatch(actionTypes.LOGOUT)
                    .then(resp => {
                        this.$router.push({ name: 'login' });
                    });
                    break;
            }
        },
        showNotification(){
            if('serviceWorker' in navigator) {
                const options = {
                    body: 'Este es el cuerpo de la notificación'
                };
                navigator.serviceWorker.ready
                    .then(swreg => {
                        swreg.showNotification('Notificación desde el SW', options);
                    });
            }
        },
        requestNotificationPermission() {
            Notification.requestPermission().then(result => {
                if(result !== 'granted'){
                    toastr.error('Notificaciones bloqueadas por el usuario');
                } else {
                    this.subscribe();
                }
            });
        }
    },
    created(){
        this.initialize();
    }
}
</script>


// WEBPACK FOOTER //
// src/components/UI/NavDrawer/NavDrawer.vue